module.exports = __webpack_public_path__ + "assets/admin-cover-1d43e8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/Content/images/admin-cover.jpg
 ** module id = 920
 ** module chunks = 2
 **/